/**
 * Internal dependencies
 */
export type FindRecipesClickDatalayerProps = {
	folderAmount: string;
	totalRecipeCount: string;
};

/**
 * Pushes an event to the data layer when the find recipes button is clicked.
 * This is used for analytics tracking.
 * @param {FindRecipesClickDatalayerProps} props                  - The properties for the event.
 * @param {string}                         props.folderAmount     - The amount of folders.
 * @param {string}                         props.totalRecipeCount - The total number of recipes.
 * @return {void}
 */
export function pushKeittokirjaFindRecipesClick({
	folderAmount,
	totalRecipeCount,
}: FindRecipesClickDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_find_recipes_click',
		folder_amount: folderAmount,
		total_recipe_count: totalRecipeCount,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_find_recipes_click', datalayerObject);
	}
}
